import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { useCurrentUser } from "./useCurrentUser";

/**
 * A wrapper around useQuery that automatically adds authentication guards.
 * Only runs the query when the user is authenticated and auth state is initialized.
 */
export function useAuthenticatedQuery<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends readonly unknown[] = readonly unknown[]
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey> & {
    queryKey: TQueryKey;
    queryFn: () => Promise<TQueryFnData>;
  }
): UseQueryResult<TData, TError> {
  const { isSignedIn, authInitialized } = useCurrentUser();

  return useQuery({
    ...options,
    enabled: authInitialized && isSignedIn && (options.enabled !== false),
  });
} 